<template lang="pug">
  v-select.product-metadata-select(:value.sync="selectedOption" :clearable="clearable" @input="onInput" label="name" :options="options" :placeholder="loading ? 'Loading ...' : placeholder")
</template>

<script>
import vSelect from 'vue-select'
import Core from '@/service/apis/Core'

export default {
  props: {
    value: {
      type: Number,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Select Metadata Schema',
      required: false
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    options: [],
    selectedOption: null,
    loading: false
  }),
  created() {
    this.loading = true
    Core.getMetadataSchemas({ max: 1000 })
      .then((resp) => {
        this.options = resp.data.schema
        this.updateSelectedOption()
      })
      .catch((e) => {
        this.placeholder = e.response.data.message
      })
      .then(() => {
        this.loading = false
      })
  },
  methods: {
    updateSelectedOption() {
      if (this.value) {
        this.selectedOption = this.options.find((o) => o.id === this.value)
      } else {
        this.selectedOption = null
      }
    },
    onInput(val) {
      this.$emit('input', val ? val.id : null)
    },
    getSelectedMetadataschema() {
      return this.selectedOption
    },
    setSelectedMetadataschema(schema) {
      const exisiting = this.options.find((o) => o.id === schema.id)
      if (!exisiting) {
        this.options.push(schema)
      }
    }
  },
  watch: {
    value() {
      this.updateSelectedOption()
    }
  },
  components: {
    vSelect
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ssp/MetadataSchemaSelect.vue